import {Navigate, Route, Routes} from 'react-router-dom';
import Maintenance from '../pages/maintenance/maintenance';
import RouteWithState from '../routeWithState/routeWithState';
import ExternalRoute from '../pages/externalRoute/externalRoute';
import NotFountNew from '../pages/notFound/notFountNew';
import Login from '../pages/login/login';
import Otp from '../pages/otp/otp';
import PrivacyStatements from '../pages/privacyStatements/privacyStatements';
import OngoingDetailPurchase from '../pages/purchase/ongoingDetailPurchase';
import UnauthorizedContainer from '../pages/navigationButtonComponents/walletContainer/unauthorizedContainer';
import MainLayout from '../layouts/MainLayout ';
import GuestRoute from './GuestRoute';

export default function BasePage() {
    const environment = process.env.REACT_APP_ENV;

    // useEffect(() => {
    //     if (screen.orientation && (screen.orientation as any).lock) {
    //         (screen.orientation as any).lock('portrait').catch((err: any) => {
    //             console.error("Cannot lock orientation:", err);
    //         });
    //     }
    // }, []);

    return (
        <>
            {/* {environment !== 'prod' && (
                <div style={{
                    position: 'fixed',
                    top: '0px',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                    color: '#fff',
                    zIndex: '1200000',
                    direction: 'rtl',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    padding: '0',
                    // maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                    margin: 'auto'
                }}>
                    محیط تست
                </div>
            )} */}
            <Routes>
                <Route path="/app" element={<Navigate to="/home" replace />} />
                <Route element={<GuestRoute />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/otp" element={<Otp />} />
                </Route>
                <Route path="/privacy" element={<PrivacyStatements />} />
                <Route
                    path="/public/store/*"
                    element={<UnauthorizedContainer />}
                />
                <Route
                    path="/ongoingDetailPurchase/:key"
                    element={
                        <OngoingDetailPurchase
                            ongoingPurchases={0}
                            setState={() => {}}
                        />
                    }
                />
                <Route element={<RouteWithState />}>
                    <Route path="/" element={<Navigate to="/home" replace />} />
                    <Route element={<MainLayout />}>
                        <Route path="/home/*" element={null} />
                        <Route path="/credit/*" element={null} />
                        <Route path="/account/*" element={null} />
                        <Route path="/market/*" element={null} />
                        <Route path="/loans/*" element={null} />
                        <Route path="/menu/*" element={null} />
                    </Route>
                </Route>
                <Route
                    path="/maintenance"
                    element={<Maintenance message="مشکلی رخ داده است" />}
                />
                <Route
                    path="/externalRoute"
                    element={<ExternalRoute message="مشکلی رخ داده است" />}
                />
                <Route
                    path="*"
                    element={
                        <NotFountNew
                            message="مشکلی رخ داده است"
                            description="صفحه ای که به دنبال آن هستید یافت نشد!"
                        />
                    }
                />
            </Routes>
        </>
    );
}
